<template>
  <div class="print-thermal-container d-flex flex-column p-3 text-monospace" id="thermalPrintArea">
    <!-- Header del ticket -->
    <div class="thermal-header d-flex flex-column">
      <div class="logo-section text-center mb-2">
        <h4 class="mb-1 font-weight-bold">CENTRALGYM</h4>
        <small class="text-muted">Sistema de Gestión de Gimnasios</small>
      </div>
      <div class="separator-double"></div>
      
      <div class="col-12 d-flex justify-content-between mb-2">
        <small class="font-weight-bold text-muted">{{ fechaImpresion }}</small>
        <small class="font-weight-bold text-muted">{{ horaImpresion }}</small>
      </div>
      
      <h5 class="text-center font-weight-bold mb-1">RESUMEN DE CUADRATURA</h5>
      <p class="text-center lead font-weight-bold mb-0">{{ closureData.caja }}</p>
      <p class="text-center mb-0">{{ closureData.nombreSucursal || 'Sin sucursal' }}</p>
    </div>
    
    <!-- Información General -->
    <div class="thermal-section mt-3">
      <div class="section-title">INFORMACIÓN GENERAL</div>
      <div class="d-flex justify-content-between">
        <div class="col-7">
          <small class="d-block mb-1">RESPONSABLE:</small>
          <small class="d-block mb-1">FECHA APERTURA:</small>
          <small class="d-block mb-1">HORA APERTURA:</small>
          <small class="d-block mb-1">FECHA CIERRE:</small>
          <small class="d-block mb-1">HORA CIERRE:</small>
        </div>
        <div class="col-5 text-right">
          <small class="d-block mb-1 font-weight-bold text-truncate">{{ closureData.responsable || 'Sin responsable' }}</small>
          <small class="d-block mb-1 font-weight-bold">{{ formatDate(closureData.fechaApertura) }}</small>
          <small class="d-block mb-1 font-weight-bold">{{ closureData.horaApertura || '00:00:00' }}</small>
          <small class="d-block mb-1 font-weight-bold">{{ formatDate(closureData.fechaCierre) }}</small>
          <small class="d-block mb-1 font-weight-bold">{{ closureData.horaCierre || '00:00:00' }}</small>
        </div>
      </div>
    </div>
    
    <div class="separator-dots mt-3"></div>
    
    <!-- Resumen del Sistema -->
    <div class="thermal-section mt-3">
      <div class="section-title">RESUMEN CALCULADO POR EL SISTEMA</div>
      
      <!-- Métodos de pago -->
      <div class="payment-methods mt-2">
        <div class="d-flex justify-content-between mb-1">
          <small>EFECTIVO:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalSistema.ventasEfectivo) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>TARJETA DÉBITO:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalSistema.ventasTDebito) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>TARJETA CRÉDITO:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalSistema.ventasTCredito) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>CHEQUE:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalSistema.ventasCheque) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>TRANSFERENCIA:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalSistema.ventasTransferencia) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>CRÉDITO LOCAL:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalSistema.ventasCreditoLocal) }}</small>
        </div>
      </div>
      
      <div class="separator-simple my-2"></div>
      
      <!-- Totales Sistema -->
      <div class="totals">
        <div class="d-flex justify-content-between mb-1">
          <small class="font-weight-bold">VENTAS TOTALES:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalSistema.ventasTotales) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>CAJA INICIAL:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalSistema.cajaInicial) }}</small>
        </div>
        <div class="d-flex justify-content-between">
          <small class="font-weight-bold">TOTAL EN CAJA:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalSistema.totalEnCaja) }}</small>
        </div>
      </div>
    </div>
    
    <div class="separator-dots mt-3"></div>
    
    <!-- Resumen Ratificado -->
    <div class="thermal-section mt-3">
      <div class="section-title">RESUMEN RATIFICADO POR CAJERO</div>
      
      <!-- Métodos de pago ratificados -->
      <div class="payment-methods mt-2">
        <div class="d-flex justify-content-between mb-1">
          <small>EFECTIVO:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalRatificado.ventasEfectivo) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>TARJETA DÉBITO:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalRatificado.ventasTDebito) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>TARJETA CRÉDITO:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalRatificado.ventasTCredito) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>CHEQUE:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalRatificado.ventasCheque) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>TRANSFERENCIA:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalRatificado.ventasTransferencia) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>CRÉDITO LOCAL:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalRatificado.ventasCreditoLocal) }}</small>
        </div>
      </div>
      
      <div class="separator-simple my-2"></div>
      
      <!-- Totales Ratificados -->
      <div class="totals">
        <div class="d-flex justify-content-between mb-1">
          <small class="font-weight-bold">VENTAS TOTALES:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalRatificado.ventasTotales) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>CAJA INICIAL:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalRatificado.cajaInicial) }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small class="font-weight-bold">TOTAL EN CAJA:</small>
          <small class="font-weight-bold">${{ formatMoney(closureData.totalRatificado.totalEnCaja) }}</small>
        </div>
      </div>
    </div>
    
    <div class="separator-double mt-3"></div>
    
    <!-- Resumen de Diferencias -->
    <div class="thermal-section mt-3 difference-section" :class="{ 'has-difference': closureData.tieneDiferencias }">
      <div class="section-title">RESUMEN DE DIFERENCIAS</div>
      
      <div class="d-flex justify-content-between mb-1">
        <small>ESTADO:</small>
        <small class="font-weight-bold">
          {{ closureData.tieneDiferencias ? 'CON DIFERENCIAS' : 'SIN DIFERENCIAS' }}
        </small>
      </div>
      
      <div v-if="closureData.tieneDiferencias" class="mt-2">
        <div class="d-flex justify-content-between mb-1">
          <small>TIPO:</small>
          <small class="font-weight-bold">{{ closureData.totalRatificado.indicadorDiferencia || 'DIFERENCIA' }}</small>
        </div>
        <div class="d-flex justify-content-between mb-1">
          <small>MONTO:</small>
          <small class="font-weight-bold text-danger">
            ${{ formatMoney(Math.abs(closureData.totalRatificado.totalDiferencia || 0)) }}
          </small>
        </div>
        <div class="d-flex justify-content-between">
          <small>PORCENTAJE:</small>
          <small class="font-weight-bold">{{ closureData.porcentajeDiferencia }}%</small>
        </div>
      </div>
    </div>
    
    <!-- Archivo Adjunto -->
    <div v-if="closureData.tieneAdjunto" class="thermal-section mt-3">
      <div class="section-title">ARCHIVO ADJUNTO</div>
      <small class="d-block text-center">{{ closureData.nombreArchivo }}</small>
    </div>
    
    <!-- Footer del ticket -->
    <div class="thermal-footer mt-4">
      <div class="separator-double mb-3"></div>
      
      <div class="signature-section">
        <div class="signature-line mx-auto"></div>
        <p class="text-center mb-1 font-weight-bold">FIRMA DEL RESPONSABLE</p>
        <p class="text-center mb-0">
          <small>{{ closureData.responsable || 'Sin responsable' }}</small>
        </p>
      </div>
      
      <div class="separator-simple my-3"></div>
      
      <div class="footer-info text-center">
        <small class="d-block">CENTRALGYM - Sistema de Gestión</small>
        <small class="d-block">www.centralgym.cl</small>
        <small class="d-block mt-2">*** FIN DEL DOCUMENTO ***</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CashClosureThermalPrint',
  props: {
    closureData: {
      type: Object,
      default: () => ({
        caja: '',
        fechaApertura: '',
        fechaCierre: '',
        fechaRegistro: '',
        horaApertura: '',
        horaCierre: '',
        nombreSucursal: '',
        responsable: '',
        tieneDiferencias: false,
        porcentajeDiferencia: '0.00',
        tieneAdjunto: false,
        nombreArchivo: '',
        totalRatificado: {
          cajaInicial: 0,
          indicadorDiferencia: '',
          totalDiferencia: 0,
          totalEnCaja: 0,
          ventasCheque: 0,
          ventasCreditoLocal: 0,
          ventasEfectivo: 0,
          ventasTCredito: 0,
          ventasTDebito: 0,
          ventasTotales: 0,
          ventasTransferencia: 0
        },
        totalSistema: {
          cajaInicial: 0,
          totalEnCaja: 0,
          ventasCheque: 0,
          ventasCreditoLocal: 0,
          ventasEfectivo: 0,
          ventasTCredito: 0,
          ventasTDebito: 0,
          ventasTotales: 0,
          ventasTransferencia: 0
        }
      })
    }
  },
  
  computed: {
    fechaImpresion() {
      return this.$moment().format('DD-MM-YYYY');
    },
    
    horaImpresion() {
      return this.$moment().format('HH:mm:ss');
    }
  },
  
  methods: {
    formatDate(date) {
      if (!date) return 'Sin fecha';
      
      // Si ya viene formateada como DD-MM-YYYY, devolverla así
      if (typeof date === 'string' && date.match(/^\d{2}-\d{2}-\d{4}$/)) {
        return date;
      }
      
      // Si no, formatearla
      return this.$moment(date).isValid() 
        ? this.$moment(date).format('DD-MM-YYYY')
        : 'Sin fecha';
    },
    
    formatMoney(value) {
      if (!value && value !== 0) return '0';
      return new Intl.NumberFormat('es-CL').format(value);
    },
    
    async print() {
      const elem = document.getElementById('thermalPrintArea');
      const width = elem.offsetWidth;
      const height = elem.offsetHeight;
      
      // Nombre del archivo con información relevante
      const filename = `Cierre_${this.closureData.caja}_${this.formatDate(this.closureData.fechaCierre)}_${this.horaImpresion.replace(/:/g, '-')}.pdf`;
      
      const opt = {
        margin: [5, 0], // Márgenes mínimos para aprovechar el papel
        filename: filename,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { 
          scale: 3, // Alta calidad
          useCORS: true,
          logging: false
        },
        jsPDF: {
          unit: 'mm',
          format: [80, Math.max(297, (height + 20) * 0.264583)], // Mínimo A4 de alto, ancho térmico
          orientation: 'portrait'
        }
      };
      
      try {
        const pdf = await this.$html2pdf()
          .set(opt)
          .from(elem)
          .toPdf()
          .get('pdf');
          
        // Abrir en nueva ventana para vista previa
        window.open(pdf.output('bloburl'), '_blank');
      } catch (error) {
        console.error('Error al generar PDF:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'Error al imprimir',
          text: 'No se pudo generar el documento de impresión',
          confirmButtonColor: '#6bd098'
        });
      }
    }
  }
};
</script>

<style scoped>
/* Contenedor principal */
.print-thermal-container {
  background-color: #ffffff;
  width: 80mm;
  min-height: 297mm; /* A4 height */
  font-family: 'Courier New', monospace;
  font-size: 11px;
  line-height: 1.3;
  color: #000;
}

/* Header */
.thermal-header {
  text-align: center;
}

.logo-section h4 {
  font-size: 18px;
  letter-spacing: 2px;
}

/* Secciones */
.thermal-section {
  margin: 0 -0.5rem;
  padding: 0 0.5rem;
}

.section-title {
  background-color: #333;
  color: #fff;
  padding: 4px 8px;
  font-weight: bold;
  font-size: 10px;
  text-align: center;
  margin: 0 -0.5rem 8px -0.5rem;
  letter-spacing: 0.5px;
}

/* Separadores */
.separator-double {
  border-top: 3px double #000;
  margin: 8px 0;
}

.separator-dots {
  border-bottom: 2px dotted #666;
  margin: 8px 0;
}

.separator-simple {
  border-bottom: 1px solid #ccc;
  margin: 8px 0;
}

/* Sección de diferencias */
.difference-section.has-difference {
  border: 2px solid #dc3545;
  padding: 8px;
  border-radius: 4px;
  margin-top: 12px !important;
}

.difference-section.has-difference .section-title {
  background-color: #dc3545;
  margin: -8px -8px 8px -8px;
}

/* Footer */
.thermal-footer {
  margin-top: auto;
  padding-top: 20px;
}

.signature-line {
  width: 60%;
  height: 40px;
  border-bottom: 2px solid #000;
  margin-bottom: 8px;
}

.footer-info {
  font-size: 9px;
  color: #666;
}

/* Ajustes de texto */
.text-truncate {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Estilos de impresión */
@media print {
  .print-thermal-container {
    margin: 0;
    padding: 5mm;
    page-break-inside: avoid;
  }
  
  .thermal-section {
    page-break-inside: avoid;
  }
  
  .thermal-footer {
    page-break-inside: avoid;
  }
}

/* Montos y valores */
.font-weight-bold {
  font-weight: 700 !important;
}

.text-danger {
  color: #dc3545 !important;
}

.text-muted {
  color: #6c757d !important;
}

/* Responsive para diferentes tamaños de impresión */
@media (max-width: 80mm) {
  .print-thermal-container {
    font-size: 10px;
  }
  
  .logo-section h4 {
    font-size: 16px;
  }
  
  .section-title {
    font-size: 9px;
  }
}
</style>
